// extracted by mini-css-extract-plugin
export default {"faqItem":"FaqItem_faqItem__Jhxzl","faqTitle":"FaqItem_faqTitle__MVSvW","faqContent":"FaqItem_faqContent__vZDVU","icon":"FaqItem_icon__XZzXj"};